import {useSingleRunModeContext} from '../MultiRunWorkspace/SingleRunMode';
import {RunsLinePlotConfig} from './types';

export const useColorByMetrics = (config: RunsLinePlotConfig) => {
  const {isSingleRun} = useSingleRunModeContext();
  const isMultiMetric = config.metrics != null && config.metrics.length >= 2;
  if (!isMultiMetric) {
    return false;
  }
  return config.colorEachMetricDifferently ?? isSingleRun;
};
